import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Headphones, BookOpen } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';

// For model-test levels (TOEFL / IELTS) the homepage Practice / Daily Quick Quiz don't use the
// random-question landing flow — they launch the REAL model-test taker in the Quiz Store, so
// passages, listening audio, cloze blanks and matching render exactly like the published quiz
// and the report is the real TOEFL/IELTS submission details / performance. Requires login.
//   mode="quick"    -> the Micro tab (short, single-section model tests)
//   mode="practice" -> the Published tab (full model tests)
export default function LandingModelTestLauncher({ level, mode = 'quick' }) {
    const navigate = useNavigate();
    const { userState } = useUser();

    const view = mode === 'quick' ? 'MICRO_QUIZ' : 'PUBLISHED_QUIZ';
    const target = `/userquiz?view=${view}&level=${encodeURIComponent(level)}`;

    const go = () => {
        if (userState?.isLoggedIn) navigate(target);
        else navigate(`/login?redirect=${encodeURIComponent(target)}`);
    };

    const isQuick = mode === 'quick';
    const Icon = isQuick ? Headphones : BookOpen;

    return (
        <div
            className="text-center my-4 p-4"
            style={{
                background: '#ffffff',
                border: '1px solid #ede9fe',
                borderRadius: '0.9rem',
                boxShadow: '0 10px 24px -14px rgba(91,33,182,0.35)',
            }}
        >
            <Icon style={{ width: '2rem', height: '2rem', color: '#7c3aed' }} className="mb-2" />
            <h3 className="fw-bold" style={{ color: '#4c1d95' }}>
                {level} {isQuick ? 'Quick Practice' : 'Full Practice'}
            </h3>
            <p className="text-muted mb-3">
                {level} practice runs as a real model test — with passages, listening audio, cloze
                blanks and matching presented exactly like the exam, plus per-section band scoring.
                {isQuick
                    ? ' Quick Practice opens a short, single-section test.'
                    : ' Full Practice opens a complete model test.'}
            </p>
            <button
                className="btn"
                onClick={go}
                style={{ background: 'linear-gradient(145deg,#7c3aed,#5b21b6)', color: '#fff', fontWeight: 600, boxShadow: '0 6px 14px -6px rgba(124,58,237,0.6)' }}
            >
                {userState?.isLoggedIn
                    ? (isQuick ? 'Start Quick Practice →' : 'Browse Full Model Tests →')
                    : 'Log in to practice →'}
            </button>
            {!userState?.isLoggedIn && (
                <div className="small text-muted mt-2">Free to create an account.</div>
            )}
        </div>
    );
}
